// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS Divider INSTEAD.
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var Divider = function Divider(props) {
  var id = props.id,
    className = props.className,
    style = props.style;
  var dividerClass = function dividerClass() {
    return classNames({
      'ui-divider': true
    }, className);
  };
  return /*#__PURE__*/React.createElement("hr", {
    id: id,
    style: style,
    className: dividerClass()
  });
};
Divider.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object
};
Divider.defaultProps = {
  className: '',
  id: '',
  style: {}
};
export default Divider;